import React, { Component } from 'react';
import { connect } from 'react-redux';
import { MdAccessTime as TimeIcon } from 'react-icons/md';
import { localize } from 'react-localize-redux';

import * as landlordPayments from 'actions/landlordPaymentsActions';

import FlatButton from 'material-ui/FlatButton';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import { CSSTransitionGroup } from 'react-transition-group';

import ReportPaymentForm from './ReportPaymentForm';
import DelayPaymentForm from './DelayPaymentForm';
import ReportNSFForm from './ReportNSFForm';
import ReportLatePaymentForm from './ReportLatePaymentForm';
import EditPaymentForm from './EditPaymentForm';

import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';
import PaymentStatus from 'components/shared/PaymentStatus';
import ConfirmationDialog from 'components/shared/ConfirmationDialog';
import RentBreakdown from 'components/shared/RentBreakdown';
import PrintButton from 'components/shared/PrintButton';

import { toFriendlyDateString, toDate, formatMoney } from 'helpers/Formatter';
import { AccentColor } from 'helpers/AccentColorHelper';
import { getTranslatedString } from 'helpers/i18n';

export default withMobileDialog()(
  connect(store => {
    return {
      tenants: store.landlordPayments.tenants,
      paymentData: store.landlordPayments.paymentData,
    };
  }, landlordPayments)(
    localize()(
      class PaymentInfoDialog extends Component {
        constructor(props) {
          super(props);
          this.state = {
            delayPayment: false,
            editPayment: false,
            deleteTransactionOpen: false,
            transactionPaymentId: null,
            showConfirmationDialog: false,
            reportNSF: false,
            reportLate: false,
            isLoading: false,
          };
        }

        getPayments = () => {
          if (this.props.getAllPayments) {
            this.props.getAllPayments();
          }
        };

        handleClose = () => {
          this.props.clearPaymentInfoDialog();
          this.setState({
            delayPayment: false,
            editPayment: false,
          });
          this.props.toggleDialog();
          this.setState({
            delayPayment: false,
            editPayment: false,
            deleteTransactionOpen: false,
            transactionPaymentId: null,
            showConfirmationDialog: false,
            reportNSF: false,
            reportLate: false,
          });
        };

        unwavePayment = paymentId => {
          this.setState({ isLoading: true });
          this.props.unwavePayment(paymentId).then(() => {
            this.getPayments();
            this.handleClose();
            this.setState({ isLoading: false });
          });
        };

        wavePayment = paymentId => {
          this.setState({ isLoading: true });
          this.props.wavePayment(paymentId).then(() => {
            this.getPayments();
            this.handleClose();
            this.setState({ isLoading: false });
          });
        };

        editPayment = () => {
          this.setState({ editPayment: !this.state.editPayment });
        };

        submitForm = formData => {
          this.setState({ isLoading: true });
          return this.props.reportPayment(formData).then(() => {
            this.getPayments();
            this.handleClose();
            this.setState({ isLoading: false });
          });
        };

        submitDelayForm = formData => {
          this.setState({ isLoading: true });
          this.props.delayPayment(this.props.paymentData.id, formData).then(() => {
            this.getPayments();
            this.handleClose();
            this.setState({ isLoading: false });
          });
        };

        submitEditForm = formData => {
          this.props.updatePayment(formData, this.props.paymentData.id).then(() => {
            this.getPayments();
            this.handleClose();
          });
        };

        delayPayment = () => {
          this.setState({ delayPayment: true });
        };

        reportNSF = () => {
          this.setState({ reportNSF: true });
        };

        reportLate = () => {
          this.setState({ reportLate: !this.state.reportLate });
        };

        submitLatePayment = formData => {
          this.setState({ isLoading: true });
          this.props.submitLatePayment(this.props.paymentData.id, formData).then(() => {
            this.getPayments();
            this.reportLate();
            this.handleClose();
            this.setState({ isLoading: false });
          });
        };

        cancelNSFForm = () => {
          this.setState({ reportNSF: false });
        };

        submitNSFForm = formData => {
          this.setState({ isLoading: true });
          this.props.reportNSF(this.props.paymentData.id, formData).then(() => {
            this.getPayments();
            this.setState({
              reportNSF: false,
              isLoading: false,
            });
            this.handleClose();
          });
        };

        useDeposit = () => {
          this.setState({ isLoading: true });
          this.props.useDeposit(this.props.paymentData.id).then(() => {
            this.getPayments();
            this.handleClose();
            this.setState({ isLoading: false });
          });
        };

        cancelDelayPayment = () => {
          this.setState({ delayPayment: false });
        };

        submitDeletePayment = payment_id => {
          this.setState({ isLoading: true });
          this.props.deletePayment(payment_id).then(() => {
            this.getPayments();
            this.showConfirmationDialog(false);
            this.handleClose();
            this.setState({ isLoading: false });
          });
        };

        deleteTransactionOpen = transaction_id => {
          this.setState({ deleteTransactionOpen: true, transactionPaymentId: transaction_id });
        };

        deleteTransactionClose = () => {
          this.setState({ deleteTransactionOpen: false, transactionPaymentId: null });
        };

        showConfirmationDialog = shouldShow => {
          this.setState({
            showConfirmationDialog: shouldShow,
          });
        };

        deleteTransactionPayment = () => {
          this.setState({ isLoading: true });
          this.props.deleteTransactionPayment(this.state.transactionPaymentId).then(() => {
            this.getPayments();
            this.deleteTransactionClose();
            this.setState({ isLoading: false });
          });
        };

        displayReportNSFOption = (paymentType, paymentStatus) => {
          if (paymentStatus !== 'Paid') return null;

          return (
            <div>
              <div
                className="row"
                style={{
                  textAlign: 'center',
                  fontSize: '12px',
                  marginBottom: '15px',
                }}
              >
                <div className="row" style={{ marginTop: '10px' }}>
                  <span>
                    <button type="button" className="link-button" onClick={() => this.reportNSF()}>
                      {' '}
                      {getTranslatedString('landlordPortal.paymentInfoDialog.reportNSF')}{' '}
                    </button>
                  </span>
                </div>
              </div>
            </div>
          );
        };

        render() {
          const data = this.props.paymentData;
          const paymentStatus = data.status;
          const receiptId = data.id;
          const paymentDetails = data.payment_details || [];
          const editPaymentButton = this.state.editPayment
            ? getTranslatedString('landlordPortal.paymentInfoDialog.view')
            : getTranslatedString('landlordPortal.paymentInfoDialog.edit');

          const style = {
            bold_padding: {
              padding: '0px 5px',
              fontWeight: '800',
            },
            padding_right: {
              padding: '0px 5px',
              fontWeight: '800',
            },
            receipt_header: {
              margin: '5px -20px 10px -20px',
              backgroundColor: '#f1f1f1',
              padding: '5px 10px',
              fontSize: '14px',
              fontWeight: '800',
            },
            rent_breakdown: {
              fontSize: '15px',
              marginTop: '15px',
            },
            right_align_p: {
              textAlign: 'right',
              marginBottom: '1px',
            },
            payment_details: {
              fontSize: '13px',
            },
            payment_type_details: {
              fontSize: '13px',
              marginRight: '5px',
            },
            unit_details: {
              fontSize: '14px',
              marginBottom: '1px',
            },
            column_ellipsis: {
              padding: '0',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            },
          };

          const unitDetails = (
            <div>
              <div className="row" style={style.receipt_header}>
                <div className="col-xs-12">
                  <p style={{ margin: '0', textAlign: 'center' }}>
                    {' '}
                    {getTranslatedString('landlordPortal.paymentInfoDialog.unitDetails')}
                  </p>
                </div>
              </div>

              <div className="row">
                <div className="col-xs-8" style={{ padding: '0px 5px' }}>
                  <p style={style.unit_details}>{data.property_street}</p>
                  <p style={style.unit_details}>{data.property_city}</p>
                  <p style={style.unit_details}>{data.property_country}</p>
                </div>

                <div className="col-xs-4" style={{ textAlign: 'right', padding: '0px 5px' }}>
                  <PrintButton
                    hideElementsByIds={[
                      'report-payment',
                      'edit-payment',
                      'edit-payment-details',
                      'payment-ledger-payment-log',
                    ]}
                  />
                </div>
              </div>
            </div>
          );

          const paymentStatusBreakdown = (
            <div>
              <div className="row" style={style.receipt_header}>
                <div className="col-xs-12">
                  <p style={{ margin: '0', textAlign: 'center' }}>
                    {' '}
                    {getTranslatedString('landlordPortal.paymentInfoDialog.status')}{' '}
                  </p>
                </div>
              </div>

              <div className="row" style={{ marginTop: '20px' }}>
                <div className="col-xs-7" style={{ padding: '0px 5px' }}>
                  <p>
                    <span style={{ fontSize: '14px' }}>
                      <TimeIcon size={16} style={{ verticalAlign: 'text-bottom' }} />
                    </span>&nbsp;<b style={{ fontSize: '14px' }}>
                      {`${getTranslatedString(
                        'landlordPortal.paymentInfoDialog.dueDate'
                      )} ${toFriendlyDateString(data.due_date)}`}
                    </b>
                  </p>
                </div>
                <div className="col-xs-5" style={style.padding_right}>
                  <p style={{ fontSize: '14px', textAlign: 'right' }}>
                    <PaymentStatus status={paymentStatus} />
                  </p>
                </div>
              </div>
            </div>
          );

          const paymentTenantDetails = (
            <div>
              <div className="row" style={style.receipt_header}>
                <div className="col-xs-12">
                  <p
                    style={{
                      margin: '0',
                      textAlign: 'center',
                      textTransform: 'uppercase !important',
                    }}
                  >
                    <TenantResidentVerbiageHelper uppercase />{' '}
                    {getTranslatedString('landlordPortal.paymentInfoDialog.details')}
                  </p>
                </div>
              </div>

              <div className="row">
                <div className="col-xs-7" style={{ padding: '0', marginLeft: '5px' }}>
                  <h6 style={{ marginBottom: '5px' }}>
                    {' '}
                    {getTranslatedString('landlordPortal.paymentInfoDialog.fullName')}{' '}
                  </h6>
                </div>
                <div
                  className="col-xs-5"
                  style={{ padding: '0', textAlign: 'right', marginLeft: '-10px' }}
                >
                  <h6 style={{ marginBottom: '5px' }}>
                    {' '}
                    {getTranslatedString('landlordPortal.paymentInfoDialog.email')}{' '}
                  </h6>
                </div>
              </div>

              {data.tenants.map((tenant, index) => (
                <div key={index} className="row">
                  <div className="col-xs-7" style={{ padding: '0', marginLeft: '5px' }}>
                    <p style={style.payment_details}>{tenant.name}</p>
                  </div>
                  <div
                    className="col-xs-5"
                    style={{ padding: '0', textAlign: 'right', marginLeft: '-10px' }}
                  >
                    {tenant.email && <p style={style.payment_details}>{tenant.email}</p>}
                    {!tenant.email && (
                      <p style={style.payment_details}>
                        {getTranslatedString('landlordPortal.paymentInfoDialog.noEmail')}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          );

          const editPaymentDetails = (
            <div id="edit-payment-details">
              {data.amount_outstanding !== '$0.00' &&
                data.status !== 'Waived' &&
                !this.state.delayPayment && (
                  <div>
                    <div className="row" style={style.receipt_header}>
                      <div className="col-xs-12">
                        <p style={{ margin: '0', textAlign: 'center' }}>
                          {!this.state.editPayment && (
                            <span>
                              {getTranslatedString('landlordPortal.paymentInfoDialog.editPayment')}
                            </span>
                          )}
                          {this.state.editPayment && (
                            <span>
                              {' '}
                              {getTranslatedString(
                                'landlordPortal.paymentInfoDialog.viewPayment'
                              )}{' '}
                            </span>
                          )}
                        </p>
                      </div>
                    </div>

                    <div className="row">
                      {!this.state.editPayment && (
                        <p style={{ fontSize: '14px', marginTop: '5px', textAlign: 'center' }}>
                          {' '}
                          {getTranslatedString('landlordPortal.paymentInfoDialog.editPaymentInfo')}
                          <br />
                          {getTranslatedString(
                            'landlordPortal.paymentInfoDialog.editPaymentInfoWarn'
                          )}
                        </p>
                      )}
                      {this.state.editPayment && (
                        <p style={{ fontSize: '14px', marginTop: '5px', textAlign: 'center' }}>
                          {' '}
                          {getTranslatedString('landlordPortal.paymentInfoDialog.viewPaymentInfo')}
                        </p>
                      )}
                    </div>

                    <div className="row">
                      <div
                        className="col-xs-12"
                        style={{ padding: '0px 5px', textAlign: 'center' }}
                      >
                        <FlatButton
                          label={editPaymentButton}
                          primary={true}
                          keyboardFocused={false}
                          onClick={this.editPayment}
                          style={{ color: '#fff', backgroundColor: AccentColor() }}
                        />
                      </div>
                    </div>
                  </div>
                )}
            </div>
          );

          const showEditPaymentForm = (
            <div>
              {this.state.editPayment && (
                <div id="edit-payment">
                  <div className="row" style={style.receipt_header}>
                    <div className="col-xs-12">
                      <p style={{ margin: '0', textAlign: 'center' }}>
                        {' '}
                        {getTranslatedString('landlordPortal.paymentInfoDialog.editPayment')}
                      </p>
                    </div>
                  </div>

                  <p style={{ fontSize: '14px', marginTop: '5px', textAlign: 'center' }}>
                    {getTranslatedString('landlordPortal.paymentInfoDialog.editPaymentCTANote')}
                  </p>

                  <EditPaymentForm
                    onSubmit={this.submitEditForm}
                    initialValues={{
                      amount_due: data.amount,
                      due_date: toDate(data.due_date),
                    }}
                  />
                </div>
              )}
            </div>
          );

          const reportNSFDetails = (
            <div>
              <div className="row" style={style.receipt_header}>
                <div className="col-xs-12">
                  <p style={{ margin: '0', textAlign: 'center' }}>
                    {' '}
                    {getTranslatedString('landlordPortal.paymentInfoDialog.reportNSF')}{' '}
                  </p>
                </div>
              </div>
              <div className="row">
                <p style={{ fontSize: '14px', marginTop: '5px' }}>
                  {' '}
                  {getTranslatedString('landlordPortal.paymentInfoDialog.reportNSFInfo')}{' '}
                </p>
              </div>
              <ReportNSFForm
                onSubmit={this.submitNSFForm}
                isSubmitting={this.state.isLoading}
                initialValues={{
                  payment_delay_date: new Date(),
                }}
              />
              <div
                className="row"
                style={{
                  textAlign: 'center',
                  fontSize: '12px',
                  marginBottom: '15px',
                }}
              >
                <button type="button" className="link-button" onClick={() => this.cancelNSFForm()}>
                  {' '}
                  {getTranslatedString('landlordPortal.paymentInfoDialog.cancel')}{' '}
                </button>
              </div>
            </div>
          );

          const reportLatePaymentDetails = (
            <div>
              <div className="row" style={style.receipt_header}>
                <div className="col-xs-12">
                  <p style={{ margin: '0', textAlign: 'center' }}>
                    {' '}
                    {getTranslatedString('landlordPortal.paymentInfoDialog.reportLatePayment')}
                  </p>
                </div>
              </div>
              <div className="row">
                <p style={{ fontSize: '14px', marginTop: '5px', textAlign: 'center' }}>
                  {getTranslatedString('landlordPortal.paymentInfoDialog.reportLatePaymentInfo')}
                </p>
              </div>
              <ReportLatePaymentForm
                isSubmitting={this.state.isLoading}
                onSubmit={this.submitLatePayment}
              />
              <div
                className="row"
                style={{
                  textAlign: 'center',
                  fontSize: '12px',
                  marginBottom: '15px',
                }}
              >
                <button type="button" className="link-button" onClick={this.reportLate}>
                  {' '}
                  {getTranslatedString('landlordPortal.paymentInfoDialog.cancel')}{' '}
                </button>
              </div>
            </div>
          );

          const delayPaymentDetails = (
            <div>
              <div className="row" style={style.receipt_header}>
                <div className="col-xs-12">
                  <p style={{ margin: '0', textAlign: 'center' }}>
                    {' '}
                    {getTranslatedString('landlordPortal.paymentInfoDialog.delayPayment')}
                  </p>
                </div>
              </div>
              <div className="row">
                <p style={{ fontSize: '14px', marginTop: '5px', textAlign: 'center' }}>
                  {' '}
                  {getTranslatedString('landlordPortal.paymentInfoDialog.delayPaymentInfo')}{' '}
                </p>
              </div>
              <DelayPaymentForm
                isSubmitting={this.state.isLoading}
                onSubmit={this.submitDelayForm}
                initialValues={{
                  payment_delay_date: new Date(),
                }}
              />
              <div
                className="row"
                style={{
                  textAlign: 'center',
                  fontSize: '12px',
                  marginBottom: '15px',
                }}
              >
                <button
                  type="button"
                  className="link-button"
                  onClick={() => this.cancelDelayPayment()}
                >
                  {' '}
                  {getTranslatedString('landlordPortal.paymentInfoDialog.cancel')}{' '}
                </button>
              </div>
            </div>
          );

          const additionalPaymentOptions = (
            <div>
              <div
                className="row"
                style={{
                  textAlign: 'center',
                  fontSize: '12px',
                  marginBottom: '15px',
                }}
              >
                <button
                  type="button"
                  className="link-button"
                  disabled={this.state.isLoading}
                  onClick={() => this.wavePayment(receiptId)}
                >
                  {' '}
                  {getTranslatedString('landlordPortal.paymentInfoDialog.waivePayment')}{' '}
                </button>
                {data.historic_payments &&
                  data.historic_payments.length > 0 && (
                    <div className="row" style={{ marginTop: '3px' }}>
                      <span>
                        <button
                          type="button"
                          className="link-button"
                          disabled={this.state.isLoading}
                          onClick={() => this.reportNSF()}
                        >
                          {' '}
                          {getTranslatedString('landlordPortal.paymentInfoDialog.reportNSF')}{' '}
                        </button>
                      </span>
                    </div>
                  )}
              </div>
            </div>
          );

          const historicPaymentBreakdown = (
            <div>
              <div className="row" style={style.receipt_header}>
                <div className="col-xs-12">
                  <p style={{ margin: '0', textAlign: 'center' }}>
                    {' '}
                    {getTranslatedString('landlordPortal.paymentInfoDialog.paymentLog')}{' '}
                  </p>
                </div>
              </div>

              {data.status === 'Waived' && (
                <div style={{ textAlign: 'center' }}>
                  <p
                    style={{
                      fontSize: '12px',
                      textAlign: 'center',
                      margin: '0',
                    }}
                  >
                    {getTranslatedString('landlordPortal.paymentInfoDialog.paymentLogWaived')}
                  </p>
                  <button
                    type="button"
                    className="link-button"
                    disabled={this.state.isLoading}
                    style={{ fontSize: '12px', margin: '0' }}
                    onClick={() => this.unwavePayment(receiptId)}
                  >
                    {getTranslatedString('landlordPortal.paymentInfoDialog.paymentLogUnWaive')}
                  </button>
                </div>
              )}

              <div className="row">
                <div className="row" style={{ margin: 'auto', maxWidth: '500px' }}>
                  <div className="row">
                    <div className="col-xs-3" style={{ padding: '0' }}>
                      <h6 style={{ marginBottom: '5px' }}>
                        {' '}
                        {getTranslatedString(
                          'landlordPortal.paymentInfoDialog.paymentLogTableHeaderTenant'
                        )}{' '}
                      </h6>
                    </div>
                    <div className="col-xs-2" style={{ padding: '0' }}>
                      <h6 style={{ marginBottom: '5px' }}>
                        {' '}
                        {getTranslatedString(
                          'landlordPortal.paymentInfoDialog.paymentLogTableHeaderAmount'
                        )}{' '}
                      </h6>
                    </div>
                    <div className="col-xs-2" style={{ padding: '0' }}>
                      <h6 style={{ marginBottom: '5px' }}>
                        {' '}
                        {getTranslatedString(
                          'landlordPortal.paymentInfoDialog.paymentLogTableHeaderRefNum'
                        )}{' '}
                      </h6>
                    </div>
                    <div className="col-xs-2" style={{ padding: '0' }}>
                      <h6 style={{ marginBottom: '5px' }}>
                        {' '}
                        {getTranslatedString(
                          'landlordPortal.paymentInfoDialog.paymentLogTableHeaderReportDate'
                        )}{' '}
                      </h6>
                    </div>
                    <div className="col-xs-2" style={{ padding: '0' }}>
                      <h6 style={{ marginBottom: '5px' }}>
                        {' '}
                        {getTranslatedString(
                          'landlordPortal.paymentInfoDialog.paymentLogTableHeaderBatchId'
                        )}{' '}
                      </h6>
                    </div>
                    <div className="col-xs-1" style={{ padding: '0' }}>
                      <h6 style={{ marginBottom: '5px' }}>
                        {' '}
                        {getTranslatedString(
                          'landlordPortal.paymentInfoDialog.paymentLogTableHeaderType'
                        )}{' '}
                      </h6>
                    </div>
                  </div>
                  {data.historic_payments.map((payment, index) => (
                    <div key={index} className="row">
                      <div className="col-xs-3" style={{ padding: '0' }}>
                        <p style={style.payment_details}>{payment.tenant}</p>
                      </div>
                      <div className="col-xs-2" style={{ padding: '0' }}>
                        <p style={style.payment_details}>{formatMoney(payment.amount_in_float)}</p>
                      </div>
                      <div className="col-xs-2" style={style.column_ellipsis}>
                        <p style={style.payment_details}>{payment.ref_number}</p>
                      </div>
                      <div className="col-xs-2" style={style.column_ellipsis}>
                        <p style={style.payment_details}>
                          {toFriendlyDateString(payment.payment_provided_date)}
                        </p>
                      </div>
                      <div className="col-xs-2" style={style.column_ellipsis}>
                        <p style={style.payment_details}>{payment.batch_id}</p>
                      </div>
                      <div className="col-xs-1" style={{ padding: '0' }}>
                        <span style={style.payment_type_details}>{payment.payment_type}</span>

                        <Dialog
                          disableBackdropClick
                          modal={false}
                          open={this.state.deleteTransactionOpen}
                          fullScreen={this.props.fullScreen}
                          onClose={this.deleteTransactionClose}
                          classes={{ paper: 'form-dialog' }}
                        >
                          <DialogTitle id="add-new-amenity">
                            <h3 style={{ textAlign: 'center', margin: 0 }}>
                              {getTranslatedString(
                                'landlordPortal.paymentInfoDialog.deleteTransaction'
                              )}
                            </h3>
                          </DialogTitle>

                          <DialogContent style={{ textAlign: 'center' }}>
                            {getTranslatedString(
                              'landlordPortal.paymentInfoDialog.deleteTransactionWarn'
                            )}
                          </DialogContent>

                          <DialogActions style={{ display: 'block' }}>
                            <FlatButton
                              label={getTranslatedString('landlordPortal.paymentInfoDialog.close')}
                              id="close-button"
                              primary={true}
                              onClick={() => this.deleteTransactionClose()}
                            />
                            <FlatButton
                              label={getTranslatedString('landlordPortal.paymentInfoDialog.delete')}
                              id="submit-button"
                              primary={true}
                              onClick={() => this.deleteTransactionPayment()}
                            />
                          </DialogActions>
                        </Dialog>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          );

          const shouldReportPayment =
            data.amount_outstanding !== 0 &&
            data.status !== 'Waived' &&
            !this.state.delayPayment &&
            !this.state.reportNSF &&
            !this.state.reportLate;

          return (
            <div>
              <Dialog
                disableBackdropClick
                fullScreen={this.props.fullScreen}
                open={this.props.isOpen}
                onClose={this.handleClose}
                aria-labelledby="report-payment"
                classes={{
                  paper: 'form-dialog',
                }}
              >
                <DialogTitle id="add-new-amenity">
                  <h3 style={{ textAlign: 'center', margin: 0 }}>
                    {getTranslatedString('landlordPortal.chargeDrawer.dialogHeader')}{' '}
                  </h3>
                </DialogTitle>
                <DialogContent>
                  {unitDetails}
                  {paymentStatusBreakdown}
                  {paymentTenantDetails}

                  {/* ************ RENT BREAKDOWN ************ */}
                  <div className="row" style={style.receipt_header}>
                    <div className="col-xs-6">
                      <p style={{ margin: '0' }}>
                        {' '}
                        {getTranslatedString('landlordPortal.paymentInfoDialog.item')}{' '}
                      </p>
                    </div>
                    <div className="col-xs-6" style={{ textAlign: 'right' }}>
                      <p style={{ margin: '0' }}>
                        {' '}
                        {getTranslatedString('landlordPortal.paymentInfoDialog.amount')}{' '}
                      </p>
                    </div>
                  </div>

                  <div className="row" style={style.rent_breakdown}>
                    <RentBreakdown paymentDetails={paymentDetails} />
                  </div>

                  <div className="row" style={{ margin: '0px -20px' }}>
                    <hr style={{ margin: '10px 0' }} />
                  </div>

                  {/* ************ TOTAL PAYMENT SUMMARY PER TENANT ************ */}
                  <div className="row" style={{ fontSize: '15px', marginTop: '10px' }}>
                    <div className="col-xs-6" style={style.bold_padding}>
                      <p id="no-margin"> {getTranslatedString('total')}</p>
                    </div>
                    <div className="col-xs-6" style={style.padding_right}>
                      <p style={style.right_align_p}> {formatMoney(data.amount)} </p>
                    </div>
                  </div>

                  {/* ************ TOTAL PAYMENT SUMMARY ************ */}
                  <div className="row" style={{ fontSize: '15px', marginTop: '10px' }}>
                    <div className="col-xs-6" style={style.bold_padding}>
                      <p id="no-margin"> {getTranslatedString('totalOutstanding')}</p>
                    </div>
                    <div className="col-xs-6" style={style.padding_right}>
                      <p style={style.right_align_p}> {formatMoney(data.amount_outstanding)} </p>
                    </div>
                  </div>

                  {!data.has_transaction_payments ? editPaymentDetails : null}

                  {this.displayReportNSFOption(data.payment_type, paymentStatus)}

                  <CSSTransitionGroup
                    transitionName="fade_out_buttons"
                    style={{ width: '100%' }}
                    transitionEnterTimeout={200}
                    transitionLeaveTimeout={200}
                  >
                    <div>
                      {showEditPaymentForm}

                      {!this.state.editPayment && (
                        <div>
                          {this.state.reportNSF && reportNSFDetails}

                          {/* ************ MARK LATE PAYMENT ************ */}
                          {this.state.reportLate && reportLatePaymentDetails}

                          {/* ************ DELAY PAYMENT ************ */}
                          {this.state.delayPayment && delayPaymentDetails}

                          {/* ************ REPORT PAYMENT ************ */}
                          {shouldReportPayment && (
                            <div id="report-payment">
                              <div className="row" style={style.receipt_header}>
                                <div className="col-xs-12">
                                  <p style={{ margin: '0', textAlign: 'center' }}>
                                    {' '}
                                    {getTranslatedString(
                                      'landlordPortal.paymentInfoDialog.reportPayment'
                                    )}{' '}
                                  </p>
                                </div>
                              </div>

                              <div className="row">
                                <p style={{ fontSize: '14px', marginTop: '5px' }}>
                                  {' '}
                                  {getTranslatedString(
                                    'landlordPortal.paymentInfoDialog.reportPaymentInfo'
                                  )}{' '}
                                </p>
                              </div>

                              <div className="row">
                                <ReportPaymentForm
                                  isSubmitting={this.state.isLoading}
                                  onSubmit={this.submitForm}
                                  initialValues={{
                                    id: receiptId,
                                    amount_outstanding: data.amount_outstanding,
                                    payment_date: new Date(),
                                  }}
                                  tenants={this.props.tenants}
                                />
                              </div>

                              {/* ************ ADDITIONAL PAYMENT OPTIONS ************ */}
                              {additionalPaymentOptions}
                            </div>
                          )}

                          {/* ************ HISTORIC PAYMENT DETAILS ************ */}
                          {(data.historic_payments.length > 0 || data.status === 'Waived') &&
                            historicPaymentBreakdown}
                        </div>
                      )}
                    </div>
                  </CSSTransitionGroup>
                </DialogContent>
                <DialogActions style={{ display: 'block' }}>
                  <FlatButton
                    onClick={this.handleClose}
                    id="close-button"
                    style={{ color: AccentColor() }}
                  >
                    {getTranslatedString('landlordPortal.paymentInfoDialog.close')}
                  </FlatButton>
                  {!data.has_transaction_payments && (
                    <FlatButton
                      onClick={() => this.showConfirmationDialog(true)}
                      id="submit-button"
                      style={{
                        color: AccentColor(),
                        backgroundColor: '#fff',
                      }}
                    >
                      {getTranslatedString('landlordPortal.paymentInfoDialog.delete')}
                    </FlatButton>
                  )}
                </DialogActions>
              </Dialog>
              <ConfirmationDialog
                style={{ textAlign: 'center' }}
                showDialog={this.state.showConfirmationDialog}
                hideDialog={() => this.showConfirmationDialog(false)}
                userConfirmVerbiage={getTranslatedString('landlordPortal.paymentInfoDialog.delete')}
                userConfirmAction={this.submitDeletePayment}
                dialogTitle={getTranslatedString(
                  'landlordPortal.paymentInfoDialog.confirmDialogTitle'
                )}
                dialogBodyVerbiage={getTranslatedString(
                  'landlordPortal.paymentInfoDialog.confirmDialogBody'
                )}
                confirmId={data.id}
              />
            </div>
          );
        }
      }
    )
  )
);
